module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.boxTitle))])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Código")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##.##.##.###-#'),
      expression: "'##.##.##.###-#'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.codigo),
      expression: "dados.codigo"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "codigo",
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.codigo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "codigo", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('codigo')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Nome")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.nome),
      expression: "dados.nome"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "nome",
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "nome", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('nome')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Tipo de atendimento")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.tipo_atendimento),
      expression: "dados.tipo_atendimento"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "tipo-de-atendimento"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "tipo_atendimento", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": _vm.TIPO_ATENDIMENTO.INDIVIDUAL
    }
  }, [_vm._v("Individual")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.TIPO_ATENDIMENTO.AGRUPADO
    }
  }, [_vm._v("Agrupado")])]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('tipo-de-atendimento')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Situação")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.situacao),
      expression: "dados.situacao"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "situacao"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "situacao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": _vm.SITUACAO.ATIVA
    }
  }, [_vm._v("Ativo")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SITUACAO.INATIVA
    }
  }, [_vm._v("Inativo")])]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('situacao')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Tipo de agrupamento")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.tipo_agrupamento),
      expression: "dados.tipo_agrupamento"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "tipo_agrupamento", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Selecione o agrupamento...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.TIPO_AGRUPAMENTO.BIOQUIMICA
    }
  }, [_vm._v("Bioquimica")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.TIPO_AGRUPAMENTO.OFTALMOLOGIA
    }
  }, [_vm._v("Oftalmologia")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Sexo")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.sexo),
      expression: "dados.sexo"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "sexo"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "sexo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": _vm.SEXO.AMBOS
    }
  }, [_vm._v("Ambos")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SEXO.MASCULINO
    }
  }, [_vm._v("Masculino")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.SEXO.FEMININO
    }
  }, [_vm._v("Feminino")])]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('situacao')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Qtd. máxima")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.quantidade_maxima),
      expression: "dados.quantidade_maxima"
    }],
    staticClass: "form-control",
    attrs: {
      "maxlength": "2",
      "type": "number"
    },
    domProps: {
      "value": (_vm.dados.quantidade_maxima)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "quantidade_maxima", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Idade mínima")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.idade_minima),
      expression: "dados.idade_minima"
    }],
    staticClass: "form-control",
    attrs: {
      "maxlength": "2",
      "type": "number"
    },
    domProps: {
      "value": (_vm.dados.idade_minima)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "idade_minima", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Idade máxima")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.idade_maxima),
      expression: "dados.idade_maxima"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.dados.idade_maxima)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "idade_maxima", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Valor de referência")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.valor_referencia),
      expression: "dados.valor_referencia"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "valor-de-referencia",
      "type": "number"
    },
    domProps: {
      "value": (_vm.dados.valor_referencia)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "valor_referencia", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('valor-de-referencia')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Complexidade")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.complexidade),
      expression: "dados.complexidade"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "complexidade", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Selecione a complexidade...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.COMPLEXIDADE.BAIXA
    }
  }, [_vm._v("Baixa")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.COMPLEXIDADE.MEDIA
    }
  }, [_vm._v("Média")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.COMPLEXIDADE.ALTA
    }
  }, [_vm._v("Alta")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Tipo de financiamento")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.tipo_financiamento),
      expression: "dados.tipo_financiamento"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "tipo_financiamento", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Selecione tipo de financiamento...")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.TIPO_FINANCIAMENTO.ASSISTENCIA_FARMACEUTICA_E_MAC
    }
  }, [_vm._v("Assistência farmacêutica e MAC")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.TIPO_FINANCIAMENTO.FAEC
    }
  }, [_vm._v("FAEC - FUNDO DE Ações estratégicas e compensações")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.TIPO_FINANCIAMENTO.INCENTIVO
    }
  }, [_vm._v("Incentivo - MAC")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.TIPO_FINANCIAMENTO.MAC
    }
  }, [_vm._v("MAC - Média e alta complexidade")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.TIPO_FINANCIAMENTO.VIGILANCIA
    }
  }, [_vm._v("Vigilância em saude")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.TIPO_FINANCIAMENTO.AB
    }
  }, [_vm._v("AB - Atenção Básica")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.TIPO_FINANCIAMENTO.ASSISTENCIA_FARMACEUTICA
    }
  }, [_vm._v("Assistência farmacêutica")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Forma de organização")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.procedimento_forma_organizacao_id),
      expression: "dados.procedimento_forma_organizacao_id"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "forma-de-organizacao"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.dados, "procedimento_forma_organizacao_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Selecione a forma de organização...")]), _vm._v(" "), _vm._l((_vm.formasOrganizacao), function(formaOrganizacao, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": formaOrganizacao.id
      }
    }, [_vm._v(_vm._s(formaOrganizacao.codigo) + " - " + _vm._s(formaOrganizacao.nome))])
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('forma-de-organizacao')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.salvar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Salvar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default pull-left",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-reply"
  }), _vm._v(" Voltar")])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-89988348"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cadastros/procedimentos/form.vue
// module id = 882
// module chunks = 0